import React, { useEffect, useState } from 'react'
import {getMissionsByCommandeId} from '../../api/commande'
import { useParams,useHistory } from 'react-router'
import { GradientText } from '../../Containers/PasserCommande/PasserCommande.styles'
import LayoutAdmin from '../../Components/LayoutAdmin/LayoutAdmin'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import PointsPassageModal from '../../Components/PointsPassages/PointsPassageModal'
import MissionCard from '../../Components/MissionCard/MissionCard'
import MissionFilesModal from '../../Components/Files/MissionFilesModal'
import RouteLetterModal from '../../Components/RouteLetter/RouteLetterModal'

function MissionAdmin() {
    const  {id}=useParams()
    const history=useHistory()
    const token = useSelector((state) => state.auth.token);

    const [missions, setMissions] = useState(null)
    const [selectedMission,setSelectedMission]=useState(null)
    const [indexNumber,setIndexNumber]=useState(0)

    const [chargementEnCours,setChargementEnCours]=useState(false)
    const [chargement,setChargement]=useState(false)

    const [modalIsOpenPlace, setModalIsOpenPlace] = useState(false);
    const [modalIsOpenFiles,setModalIsOpenFiles]=useState(false)
    const [modalIsOpenRouteLetters,setModalIsOpenRouteLetters]=useState(false)

    async function fetchMissions(id) {
        setChargementEnCours(true)
        try {
            const res = await getMissionsByCommandeId(id,token)
            setMissions(res)
        } catch (error) {
            toast.error("Une erreur s'est produite", {
                style: {
                    fontFamily: 'Montserrat',
                },
            });
        }finally{
            setChargementEnCours(false)

        }
       

    }

    

    useEffect(() => {
        if (id) {
            fetchMissions(id)
        }
    }, [id,chargement])
   
  return (
    <LayoutAdmin>
        <div
                style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: '2rem',
                    paddingBottom: '4rem',
                    fontFamily: 'Montserrat',
                }}
            >
                <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <div
                            onClick={() => {
                                history.goBack()
                            }}
                            style={{
                                background: '#51C7F2',
                                width: '3rem',
                                height: '3rem',
                                borderRadius: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                            }}
                        >
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width={14.017}
                                height={14.11}
                                viewBox='0 0 14.017 14.11'
                                
                            >
                                <g
                                    data-name='Group 11287'
                                    fill='none'
                                    stroke='#fff'
                                    strokeWidth={2}
                                >
                                    <path
                                        data-name='Path 11687'
                                        d='M16.6 11.818l-6.348 6.349 2.115 2.115 4.232 4.232'
                                        transform='translate(-8.838 -11.113)'
                                    />
                                    <path
                                        data-name='Path 11688'
                                        d='M22.147 11.818l-6.348 6.349 6.348 6.348'
                                        transform='translate(-8.838 -11.113)'
                                    />
                                </g>
                            </svg>
                        </div>

                        <div
                            style={{
                                width: '1rem',
                            }}
                        />

                        <GradientText marginTop={'unset'}>
                            {`Gestion des  missions`.toUpperCase()}
                        </GradientText>
                    </div>
                    {chargementEnCours ? 
                    <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'white',
                      marginTop:'10rem'
                    }}
                    >
                    <div className='customLoader'></div>	
                    </div> 
                   :
                   <div
                    style={{width:'100%',marginTop:'1rem'
                    }}>
                    {missions?.map((mission, index) => (
                    
                    <MissionCard 
                    key={index}
                    mission={mission}
                    hideAssign
                    hidecancel
                    hideHistoryChauffeur
                    hideChauffeur
                    hideAddForfait
                    hideValidateMission
                    hideFiles
                    onClickPlaces={()=>{
                        setSelectedMission(mission)
                        setModalIsOpenPlace(true);
                    }} 
                   
                    
                    onClickFiles={()=>{
                        setSelectedMission(mission)
                        setIndexNumber(index)
                        setModalIsOpenFiles(true)
                    }}
                    onClickRouteLetters={()=>{
                        setSelectedMission(mission)
                        setIndexNumber(index)
                        setModalIsOpenRouteLetters(true)
                    }}
                    index={index}  
                    setChargement={setChargement}
                    
                    />
                   
                    
                    ))}
                   </div>
                   }
        </div>
        <PointsPassageModal 
              isOpen={modalIsOpenPlace} 
              onClose={() => setModalIsOpenPlace(false)}
              missionId={selectedMission?._id}
        />
        
        <MissionFilesModal
           isOpen={modalIsOpenFiles}
           onClose={()=>setModalIsOpenFiles(false)}
           missionId={selectedMission?._id}
           index={indexNumber}
        />
        <RouteLetterModal
           isOpen={modalIsOpenRouteLetters}
           onClose={()=>setModalIsOpenRouteLetters(false)}
           missionId={selectedMission?._id}
           taux_chargement={selectedMission?.taux_chargement}
           total_kilometrage={selectedMission?.total_kilometrage}
           total_horaire={selectedMission?.duree_mission}
           depotAddress={selectedMission?.adresse_debut?.label}
        
           index={indexNumber}
        />
        
      
          

    </LayoutAdmin>
  )
}

export default MissionAdmin